import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { GetZipCode, ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import States from "../../../../utils/Constants"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Loader from "../../../shared/Loader/Loader"
// import NpiRegistry from "../../../General/NpiRegistry"
import handleNumericCheck from "../../../../utils/HandleNumericKeys"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ReactInputMask from "react-input-mask"
import Audit from "../../../General/Audit"
import ModalHeader from "../../Shared/ModalHeader"
import ModalFooter from "../../Shared/ModalFooter"
import SuperSearchList from "../../../shared/SuperSearch/SuperSearchList"
import SuperSearch from "../../../shared/SuperSearch/SuperSearch"
import handleAlphabeticCheck from "../../../../utils/HandleAlphabetKeys"
import { useSelector } from "react-redux"
import InputMask from 'react-input-mask';
import FormatPhoneNumber from "../../../../utils/FormatPhoneNumber";
import DropdownValueHandler from "../../../shared/SuperSearch/DropdownValueHandler"
import UpdateReduxDropDowns from "../../../shared/UpdateReduxDropDowns"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddNewEmployer = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Account', 'Employer')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Employer')?.IsDeleted
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        ProviderLNameVal: "",
        ProviderFNameVal: "",
        NPILengthVal: "",
        SSNLengthVal: "",
        FaxNumberLengthVal: "",
        ContactNumberLenghtVal: "",
        EmailAddressVal: "",
        ZipCodeLengthVal: "",
        WebsiteVal: "",
        ZipCodeDigitVal: ""
    }
    let Provider_Modal = {
        // PracticeID: 113,
        LastName: "",
        FirstName: "",
        MI: "",
        NPI: "",
        EmpID: '',
        ContactName:'',
        TaxonomyCode: '',
        SSN: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        ZipCode: "",
        ContactNumber: "",
        Email: "",
        FaxNumber: "",
        Website: "",
        DEANum: "",
        MedicareNum: "",
        MedicaidNum: "",
        BlueSheildNum: "",
        BlueCrossNum: "",
        CommercialNum: "",
        ChampusNum: "",
        StateLicenseNumber: '',
        PayToAddressLine1: "",
        PayToAddressLine2: "",
        PayToCity: "",
        PayToState: "",
        PayToZipCode: "",
        EnteredBy: ""
    }
    const [RefProviderID, setRefProviderID] = useState()
    const [practiceID, setPracticeID] = useState()
    const [providerValidationModal, setProviderValidationModal] = useState(ValidationModal)
    const [providerSaveUpdateModal, setProviderSaveUpdateModal] = useState({})
    const [mainProvidereModal, setmainProvidereModal] = useState(Provider_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.General
    const { isOpenRefProvider, npiModal, onCloseProocedNpi, proceedHeader, onClose, onDeleteProvider, type } = { ...props }
    const [del, setDel] = useState(false)
    // const [NpiRegistryNumber, setNpiRegistryNumber] = useState();
    // const [isOpenRegistry, setIsOpenRegistry] = useState(false);
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const [statesValue, setStatesValue] = useState({ value: '', display: '' })
    const [TaxonomyCode, setTaxonomyCode] = useState({ Code: '', MedicareSpecialityCode: '' })
    const [TaxonomyDD, setTaxonomyDD] = useState([]);
    const [onRefProviderSaved, setOnRefProviderSaved] = useState(false);
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [is, setIs] = useState(false);
    const [errorOnPaste, seterrorOnPaste] = useState(false)
    const [selectedClassification, setSelectedClassification] = useState('');
    useEffect(() => {
        // right now, using hard-coded value, later it will be fetched from redux
        // setPracticeID(PracticeID)
        // right now, use any providerid to test update case/find by id
        if (props.RefProviderID != null) {
            setRefProviderID(props.RefProviderID)
            setDel(true)
        } else {
            if (!onRefProviderSaved) {
                setRefProviderID(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
        if (!isNull(RefProviderID)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": RefProviderID,
                "TableName": enumUtil.enumAPITableName.EMPLOYER

            }).then((response) => {
                setIsLoading(false)
                setIs(true)
                response.State = DropdownValueHandler(States, response.State)
                if (!isNull(response.ContactNumber)) {
                    response.ContactNumber = FormatPhoneNumber(response.ContactNumber)
                }
                setmainProvidereModal(response)
                setSelectedClassification(response.ClassificationSpecialization);
                // setPracticeID(response.PracticeID)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [RefProviderID])
    const handleRefProviderChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainProvidereModal };
        let saveModal = { ...providerSaveUpdateModal }
        if (name === 'ContactNumber') {
            const formattedValue = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            modal[name] = !formattedValue[2] ? formattedValue[1] : '(' + formattedValue[1] + ') ' + formattedValue[2] + (formattedValue[3] ? '-' + formattedValue[3] : '');
        }
        else if (name === 'ZipCode') {
            GetZipCode(value)
                .then(data => {
                    setmainProvidereModal(prevState => ({ ...prevState, ...data?.main }));
                    setProviderSaveUpdateModal(prevState => ({ ...prevState, ...data?.save }));
                })
                .catch(error => {
                });
            modal[name] = value;
        }
        else {
            modal[name] = value;
        }
        setmainProvidereModal(modal)
        for (var property in Provider_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setProviderSaveUpdateModal(saveModal)
    }
    // validate Practice Modal 
    const ProviderValidation = async () => {
        let PhoneNumber = "";
        let faxNumber = "";
        if (!isNull(mainProvidereModal.ContactNumber)) {
            PhoneNumber = mainProvidereModal.ContactNumber.replace(/[()-\s]/g, "");
        }
        if (!isNull(mainProvidereModal.FaxNumber)) {
            faxNumber = mainProvidereModal.FaxNumber.replace(/-/g, "");
        }
        let ValidationModal = {
            ProviderLNameVal: FormValidator(
                mainProvidereModal.LastName,
                enumUtil.enumValidationType.Required,
                'Last Name',
            ),
            ProviderFNameVal: FormValidator(
                mainProvidereModal.FirstName,
                enumUtil.enumValidationType.Required,
                'First Name',
            ),
            NPILengthVal: FormValidator(
                mainProvidereModal.NPI,
                enumUtil.enumValidationType.Length,
                'NPI',
                10
            ),
            FaxNumberLengthVal: FormValidator(
                faxNumber,
                enumUtil.enumValidationType.Length,
                'Fax Number',
                10
            ),
            ContactNumberLenghtVal: FormValidator(
                PhoneNumber,
                enumUtil.enumValidationType.Length,
                'Contact Number',
                10
            ),
            SSNLengthVal: FormValidator(
                mainProvidereModal.SSN,
                enumUtil.enumValidationType.Length,
                'SSN',
                9
            ),
            EmailAddressVal: FormValidator(
                mainProvidereModal.Email,
                enumUtil.enumValidationType.Email,
                'Email',
            ),
            ZipCodeLengthVal: FormValidator(
                mainProvidereModal.ZipCode,
                enumUtil.enumValidationType.Lengths,
                'Zip Code',
                5, 9
            ),
            WebsiteVal: FormValidator(
                mainProvidereModal.Website,
                enumUtil.enumValidationType.Website,
                'Website',
            ),
            ZipCodeDigitVal: FormValidator(
                mainProvidereModal.ZipCode,
                enumUtil.enumValidationType.Digit,
                'Zip Code',
            ),
        }
        await setProviderValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveProvider = async () => {
        await ProviderValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            // providerSaveUpdateModal['PracticeID'] = practiceID;
            if (providerSaveUpdateModal.FaxNumber != null) {
                providerSaveUpdateModal['FaxNumber'] = providerSaveUpdateModal.FaxNumber.replace(/-/g, "");
            }
            if (providerSaveUpdateModal.ContactNumber != null) {
                providerSaveUpdateModal['ContactNumber'] = providerSaveUpdateModal.ContactNumber.replace(/[()-\s]/g, "");
                providerSaveUpdateModal.ContactNumber = providerSaveUpdateModal.ContactNumber.slice(0, 10);
            }
            setProviderSaveUpdateModal(providerSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.EMPLOYER,
                ID: RefProviderID,
                Data: { ...providerSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    if (!isNull(response.id)) {
                        setIsLoading(false)
                        // UpdateReduxDropDowns(RefProviderID, DropDowns.Provider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)
                        // UpdateReduxDropDowns(RefProviderID, DropDowns.RefProvider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)        //////
                        // UpdateReduxDropDowns(RefProviderID, DropDowns.BillingProvider, response.id, mainProvidereModal.LastName + ' , ' + mainProvidereModal.FirstName)

                        // if(RefProviderID === 0){
                        //     let obj = {value: response.id- "", display: mainProvidereModal.LastName + mainProvidereModal.FirstName}
                        //     DropDowns.Provider.push(obj)
                        //     DropDowns.RefProvider.push(obj)
                        //     DropDowns.BillingProvider.push(obj)
                        // }
                        NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success)
                        setRefProviderID(response.id)
                        setOnRefProviderSaved(true)
                        onDeleteProvider()
                        // Setting Save model to null
                        //setProviderSaveUpdateModal('')
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    console.log('error', error);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const handleRefProviderDelete = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + "/DeleteSingleRecord", 'post', {
            "ID": RefProviderID,
            "TableName": enumUtil.enumAPITableName.EMPLOYER
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Deleted Successfully!', enumUtil.enumtoaster.success)
        }).catch((error) => {
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
            setIsLoading(false)
        })
        onClose()
    }
    // const handleNpiRegistry = () => {
    //     if (mainProvidereModal.NPI != undefined) {
    //         setNpiRegistryNumber(mainProvidereModal.NPI)
    //     }
    //     setIsOpenRegistry(true);
    //     setIsLoading(false);
    //     onCloseProocedNpi();
    // }
    // const CloseRegistry = (data) => {
    //     console.log(data);
    //     setIs(true)
    //     if (data === NpiRegistryNumber) {
    //         setNpiRegistryNumber(data)
    //     }
    //     mainProvidereModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainProvidereModal.FirstName
    //     mainProvidereModal.LastName = !isNull(data.LastName) ? data.LastName : mainProvidereModal.LastName
    //     // mainProvidereModal.ContactPersonName = data.ContactPersonName
    //     mainProvidereModal.AddressLine1 = data.AddressLine1
    //     mainProvidereModal.AddressLine2 = data.AddressLine2
    //     mainProvidereModal.City = data.City
    //     mainProvidereModal.State = DropdownValueHandler(States, data.State)
    //     // mainProvidereModal.State = data.State
    //     mainProvidereModal.ZipCode = data.ZipCode
    //     const formattedcontactNumber = !isNull(data.ContactPhoneNumber) ? FormatPhoneNumber(data.ContactPhoneNumber) : ''
    //     mainProvidereModal.ContactPhoneNumber = formattedcontactNumber
    //     providerSaveUpdateModal.ContactPhoneNumber = formattedcontactNumber
    //     mainProvidereModal.NPI = data.NPI
    //     mainProvidereModal.FaxNumber = data.FaxNumber
    //     mainProvidereModal.TaxonomyCode = data.TaxonomyCode
    //     // setTaxonomyCode({ Code: data.TaxonomyCode, MedicareSpecialityCode: data.MedicareSpecialityCode })
    //     //SaveUpdateModal
    //     providerSaveUpdateModal.FirstName = !isNull(data.FirstName) ? data.FirstName : mainProvidereModal.FirstName
    //     providerSaveUpdateModal.LastName = !isNull(data.LastName) ? data.LastName : mainProvidereModal.LastName
    //     // providerSaveUpdateModal.ContactPersonName = data.ContactPersonName
    //     providerSaveUpdateModal.AddressLine1 = data.AddressLine1
    //     providerSaveUpdateModal.AddressLine2 = data.AddressLine2
    //     providerSaveUpdateModal.City = data.City
    //     providerSaveUpdateModal.State = data.State
    //     providerSaveUpdateModal.ZipCode = data.ZipCode
    //     providerSaveUpdateModal.ContactPhoneNumber = data.ContactPhoneNumber
    //     providerSaveUpdateModal.NPI = data.NPI
    //     providerSaveUpdateModal.TaxonomyCode = data.TaxonomyCode
    //     providerSaveUpdateModal.FaxNumber = data.FaxNumber

    //     setIsOpenRegistry(false)
    // }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    // const onCloseNpi = () => {
    //     setIsOpenRegistry(false)
    // }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent'} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} TableName={enumUtil.enumAPITableName.EMPLOYER} ID={RefProviderID} onClose={onDeleteProvider} API_URL={API_URL}  />
    }
    // let PopupScreen = "";
    // if (isOpenRegistry) {
    //     PopupScreen = <NpiRegistry isOpenRegistry={isOpenRegistry} NpiNumber={NpiRegistryNumber} onClosee={CloseRegistry} onCloseNpi={onCloseNpi} ClassName='npi-panel npi-open npi_detail_popup' />
    // }
    const SetRefProviderName = () => {
        if (mainProvidereModal.LastName != null && mainProvidereModal.LastName != "") {
            return (
                <p className="heading sm">{mainProvidereModal.LastName}{' '}{mainProvidereModal.FirstName}</p>
            )
        } else {
            return (
                <p className="heading sm">Add New Employer</p>
            )
        }
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={RefProviderID + ""} TableName={enumUtil.enumAPITableName.RefProvider} />
    }
    const handleSelectedData = (selectedData, name, type) => {
        console.log(selectedData, name, type);
        let modal = { ...mainProvidereModal };
        if (type === 'client' && !isNull(selectedData)) {
            if (name === 'State') {
                modal[name] = selectedData.display
                providerSaveUpdateModal[name] = selectedData.value;
            }

        } else if (type === 'server' && !isNull(selectedData)) {
            if (name === 'TaxonomyCode') {
                modal['TaxonomyCode'] = selectedData.Code
                // setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: selectedData.Code })
                providerSaveUpdateModal['TaxonomyCode'] = selectedData.Code
            }
        } else {

            modal[name] = ''
            providerSaveUpdateModal[name] = ''
        }
        setmainProvidereModal(modal)

        return selectedData
    }
    const getTaxonomyCodeSelected = (selectedData, name, type) => {
        if (!isNull(selectedData)) {
            if (type === 'client') {
                if (name === 'State') {
                }
            } else if (type === 'server') {
                if (name === 'TaxonomyCode') {
                    setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: selectedData.Code })
                    providerSaveUpdateModal['TaxonomyCode'] = selectedData.Code
                    setSelectedClassification(selectedData.ClassificationSpecialization);
                }
            }
        } else {
            if (name === "TaxonomyCode") {
                setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: '' })
                providerSaveUpdateModal['TaxonomyCode'] = ''
                setSelectedClassification('');
            }
        }
        return selectedData
    }
    const AddNewRefProvModalBody = () => {
        return (
            <div className="d-flex fa-layout h-100">
                {isLoading ? <Loader /> : null}
                <div className="form-col w-35">
                    <div className="pe-4">
                        <div className="form-group input">
                            <label htmlFor="">Last Name<span className='req'>*</span></label>
                            <div className={providerValidationModal.ProviderLNameVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="LastName"
                                    id="LastName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainProvidereModal.LastName}
                                    onChange={handleRefProviderChange}
                                />
                                {providerValidationModal.ProviderLNameVal}
                            </div>
                        </div>
                        <div className="form-group input">
                            <label htmlFor="">First Name<span className='req'>*</span></label>
                            <div className={providerValidationModal.ProviderFNameVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="FirstName"
                                    id="FirstName"
                                    autoComplete="off"
                                    maxLength={35}
                                    value={mainProvidereModal.FirstName}
                                    onChange={handleRefProviderChange}
                                />
                                {providerValidationModal.ProviderFNameVal}
                            </div>
                            {/* error helperText="Error Message" */}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">MI</label>
                            <input type="text"
                                className='form-control'
                                name="MI"
                                id="MI"
                                autoComplete="off"
                                maxLength={3}
                                value={mainProvidereModal.MI}
                                onChange={handleRefProviderChange}
                                onKeyPress={(event) => handleAlphabeticCheck(event)}
                            />
                        </div>
                        {/* <div className="form-group input">
                            <label htmlFor="">NPI</label>
                            <div className={providerValidationModal.NPILengthVal ? 'form-group input error' : 'form-group input'}>
                                <div className='field-icon'>
                                    <input type="text"
                                        className='form-control'
                                        name="NPI"
                                        id="NPI"
                                        autoComplete="off"
                                        maxLength={10}
                                        value={mainProvidereModal.NPI}
                                        onChange={handleRefProviderChange}
                                        onKeyPress={(event) => handleNumericCheck(event)}
                                    />
                                    <div className='last'>
                                        <div className="app_tooltip left" onClick={handleNpiRegistry}>
                                            <div className='NPI-R-circle'>R</div>
                                            <p class="tool_tip xsm_text text-light">NPI Registry</p>
                                        </div>
                                    </div>
                                </div>
                                {providerValidationModal.NPILengthVal}
                            </div>
                        </div> */}
                        {/* <div className='form-group input'>
                            <label htmlFor="">Taxonomy Code </label>
                            <SuperSearch
                                ApiLink={API_URL + "/InstantSearch"}
                                method="post"
                                postBody={{
                                    "TableName": enumUtil.enumAPITableName.Taxonomy,
                                    "SearchParam": mainProvidereModal.TaxonomyCode,
                                }}
                                tableHeight={400}
                                tableWidth="400px"
                                id={'TaxonomyCode'}
                                getSelectedData={(value) => getTaxonomyCodeSelected(value, "TaxonomyCode", "server")}
                                onChange={(e) => setmainProvidereModal({ ...mainProvidereModal, TaxonomyCode: e.target.value })}
                                searchValue={mainProvidereModal.TaxonomyCode}
                                tableData={[
                                    // { columName: 'ID', bindingValue: 'TaxonomyID', },
                                    { columName: 'Code', bindingValue: 'Code', },
                                    { columName: 'Medicare Speciality Code', bindingValue: 'MedicareSpecialityCode', },
                                ]}
                                disabled={false}
                                sup_btn='sup_btn-Inp'
                                sup_inp='superSearchVisitInp'
                            />
                        </div> */}
                        <div class="form-group input yellow-box">
                            <p class="mb-0">{selectedClassification} </p>
                        </div>
                        <div className="form-group input">
                            <label htmlFor="">SSN</label>
                            <div className={providerValidationModal.SSNLengthVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    className='form-control'
                                    name="SSN"
                                    id="SSN"
                                    autoComplete="off"
                                    maxLength={9}
                                    value={mainProvidereModal.SSN}
                                    onChange={handleRefProviderChange}
                                    onKeyPress={(event) => handleNumericCheck(event)}
                                />
                                {providerValidationModal.SSNLengthVal}
                            </div>
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="">EmployerID #</label>
                            <input type="text"
                                className='form-control'
                                name="EmpID"
                                id="EmpID"
                                autoComplete="off"
                                // maxLength={3}
                                value={mainProvidereModal.EmpID}
                                onChange={handleRefProviderChange}
                            // onKeyPress={(event) => handleAlphabeticCheck(event)}
                            />
                        </div>
                    </div>
                </div>
                <div className="accordian-col w-65">
                    <div className="app-accordian">
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="RProvider1-header"
                                aria-controls="RProvider1-content"
                            >
                                <p className="heading">Address Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 1</label>
                                            <input type="text" className='form-control'
                                                name="Address1"
                                                id="Address1"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.Address1}
                                                onChange={handleRefProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">Address Line 2</label>
                                            <input type="text" className='form-control'
                                                name="Address2"
                                                id="Address2"
                                                autoComplete="off"
                                                maxLength={55}
                                                value={mainProvidereModal.Address2}
                                                onChange={handleRefProviderChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row row-gap-15 row-half mt-3'>
                                    <div className="col-md-6">
                                        <div className='input'>
                                            <label htmlFor="">City</label>
                                            <input type="text" className='form-control'
                                                name="City"
                                                id="City"
                                                autoComplete="off"
                                                maxLength={30}
                                                value={mainProvidereModal.City}
                                                onChange={handleRefProviderChange} />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className='input'>
                                            <label htmlFor="">State</label>
                                            <SuperSearchList
                                                type="client"
                                                id='State'
                                                name='State'
                                                searchValue={mainProvidereModal.State}
                                                data={States}
                                                onChange={handleRefProviderChange}
                                                getSelectedData={handleSelectedData}
                                                is={is}
                                                sup_btn='sup_btn-Inp'
                                                sup_inp='superSearchVisitInp'
                                            // filterWith="startsWith"
                                            // tableHeight="200px"
                                            // tableWidth="100%"
                                            />

                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group input">
                                            <label htmlFor="">Zip Code</label>
                                            <div className={providerValidationModal.ZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal ? 'input error' : 'input'}>
                                                <input type="text" className='form-control'
                                                    name="ZipCode"
                                                    id="ZipCode"
                                                    autoComplete="off"
                                                    maxLength={9}
                                                    value={mainProvidereModal.ZipCode}
                                                    onChange={handleRefProviderChange}
                                                />
                                                {providerValidationModal.ZipCodeLengthVal || providerValidationModal.ZipCodeDigitVal}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion defaultExpanded>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                id="RProvider2-header"
                                aria-controls="RProvider2-content"
                            >
                                <p className="heading">Contact Information</p>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='row row-gap-15 row-half'>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Name</label>
                                            <div className= 'form-group input'>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    // placeholder="(555) 555-5555"
                                                    name="ContactName"
                                                    id="ContactName"
                                                    autoComplete="off"
                                                    value={mainProvidereModal.ContactName}
                                                    onChange={handleRefProviderChange}
                                                    // onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Contact Number</label>
                                            <div className={providerValidationModal.ContactNumberLenghtVal ? 'form-group input error' : 'form-group input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    placeholder="(555) 555-5555"
                                                    name="ContactNumber"
                                                    id="ContactNumber"
                                                    autoComplete="off"
                                                    value={mainProvidereModal.ContactNumber}
                                                    onChange={handleRefProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {providerValidationModal.ContactNumberLenghtVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Email Address</label>
                                            <div className={providerValidationModal.EmailAddressVal ? 'input error' : 'input'}>
                                                <input
                                                    type="text"
                                                    className='form-control'
                                                    maxLength={50}
                                                    name="Email"
                                                    id="Email"
                                                    autoComplete="off"
                                                    value={mainProvidereModal.Email}
                                                    onChange={handleRefProviderChange}
                                                />
                                                {providerValidationModal.EmailAddressVal}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group input">
                                            <label htmlFor="">Fax Number</label>
                                            <div className={providerValidationModal.FaxNumberLengthVal ? 'form-group input error' : 'form-group input'}>
                                                <ReactInputMask type="text"
                                                    className='form-control'
                                                    maskChar={0}
                                                    mask='999-999-9999'
                                                    name="FaxNumber"
                                                    id="FaxNumber"
                                                    autoComplete="off"
                                                    value={mainProvidereModal.FaxNumber}
                                                    onChange={handleRefProviderChange}
                                                    onKeyPress={(event) => handleNumericCheck(event)}
                                                />
                                                {providerValidationModal.FaxNumberLengthVal}
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <React.Fragment>
            {DeleteConfirmation}
            {type && type === "Wizard" ?
                <div>
                    {AuditPopup}
                    <div className="pb-15">
                        {AddNewRefProvModalBody()}
                    </div>
                    <ModalFooter isSaved={onRefProviderSaved ? onDeleteProvider : onClose} handleSave={handleSaveProvider} UpdatedDate={mainProvidereModal.UpdatedDate} UpdatedBy={mainProvidereModal.UpdatedBy} ID={RefProviderID} IsEditAllowed={IsEditAllowed} />
                    {/* {PopupScreen} */}
                </div> :
                <Modal show={isOpenRefProvider} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal modal-lg hk-modal-v1">
                    {AuditPopup}
                    <Modal.Body>
                        <ModalHeader HeaderName={SetRefProviderName} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onRefProviderSaved ? onDeleteProvider : onClose} key={614} Name={'Ref. Provider'} />
                        {AddNewRefProvModalBody()}
                        {/* {PopupScreen} */}
                    </Modal.Body>
                    <ModalFooter isSaved={onRefProviderSaved ? onDeleteProvider : onClose} handleSave={handleSaveProvider} UpdatedDate={mainProvidereModal.UpdatedDate} UpdatedBy={mainProvidereModal.UpdatedBy} ID={RefProviderID} IsEditAllowed={IsEditAllowed} />
                </Modal>
            }
        </React.Fragment>
    )
}

export default AddNewEmployer